import React, { useEffect, useRef, useState } from "react";
import axios from "../../API/axios";
import { set } from "react-ga";

const EditComment = ({
    isEditing,
    editedComment,
    handleCommentChange,
    handleSave,
    setIsEditing,
    dynamicValues,
    setEditedDynamicValue
}) => {
    const sessionId = localStorage.getItem("sessionId");

    const [content, setContent] = useState();
    const [postInputValue, setPostInputValue] = useState("");
    const [postDynamicValues, setPostDynamicValues] = useState([])
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [mentionType, setMentionType] = useState("");
    const [query, setQuery] = useState(""); // Store the full query
    const editorRef = useRef(null);
    const [cursorPosition, setCursorPosition] = useState(0);
    const [isDynamicValueChange, setIsDynamicValueChange] = useState(false);
    const [oldPostInputValue, setOldPostInputValue] = useState();
    const [oldDynamicValue, setOldDynamicValue] = useState();
    const [count, setCount] = useState(0);
    const [SearchText, setSearchText] = useState("")
    const [initialValues, setInitialValues] = useState('')
    const [saveDisabled, setSaveDisabled] = useState(false)
    console.log("content", content);
    console.log("postInputValue", postInputValue);
    console.log("postDynamicValues", postDynamicValues);


    useEffect(() => {
        if (count === 0) {
            setOldPostInputValue(editedComment);
            setOldDynamicValue(dynamicValues);
        }
    }, [count])

    useEffect(() => {
        if(content === initialValues) {
            setSaveDisabled(true)
        } else {
            setSaveDisabled(false)
        }
    }, [content])


    useEffect(() => {
        // setContent(editedComment)
        setCount(1);
        let updatedDynamicValues = isDynamicValueChange ? postDynamicValues : dynamicValues
        const parsed = parseComment(editedComment, updatedDynamicValues);
        setPostInputValue(editedComment)
        setContent(parsed);
        setInitialValues(parsed)
    }, []);

    const handleSaveComment = () => {
        try {
            let updatedDynamicValues = isDynamicValueChange ? postDynamicValues : dynamicValues;
            handleCommentChange(postInputValue, updatedDynamicValues);
            handleSave();
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        let updatedDynamicValues = isDynamicValueChange ? postDynamicValues : dynamicValues;
        handleCommentChange(postInputValue, updatedDynamicValues);
        setEditedDynamicValue(postDynamicValues);
    }, [postInputValue, postDynamicValues])

    // 1. Create placeholder map dynamically
    const createPlaceholderMap = (dynamicValues) => {
        const map = {};
        dynamicValues?.forEach(({ dVno, displayName, type }) => {
            if (type === "UserMention") {
                map[dVno] = `@${displayName}`;
            } else if (type === "Hashtag") {
                map[dVno] = `#${displayName}`;
            } else {
                map[dVno] = displayName; // fallback
            }
        });
        return map;
    };

    // 2. Parse and replace comment placeholders
    const parseComment = (apiComment, dynamicValues) => {
        const placeholderMap = createPlaceholderMap(dynamicValues);

        let parsedText = apiComment;

        Object.keys(placeholderMap).forEach((key) => {
            const regex = new RegExp(`\\{${key}\\}`, 'g');
            parsedText = parsedText?.replace(regex, placeholderMap[key]);
        });

        // Strip HTML tags
        parsedText = parsedText?.replace(/<[^>]*>/g, '');

        return parsedText?.trim();
    };

    // 3. Parse only once when editing starts
    useEffect(() => {
        console.log("inside useffect postInputValue", postInputValue)
        if (isEditing && content?.includes('{')) {
            let updatedDynamicValues = isDynamicValueChange ? postDynamicValues : dynamicValues
            // const parsed = parseComment(content, dynamicValues);
            const parsed = parseComment(content, updatedDynamicValues);
            //alam - Code changes
            // setPostInputValue(parsed); // Update parent state
            // alam - code changes
            setContent(parsed);
        } else {
            if (content !== "" && content !== undefined && content.length > 0) {
                setContent(content);
            }
        }
    }, [isEditing, content, dynamicValues]);

    // Handle typing in textarea
    const handleChange = (e) => {
        const value = e.target.value;
        const caret = e.target.selectionStart;

        // setPostInputValue(value)
        setContent(value);
        setCursorPosition(caret);
        detectTrigger(value, caret);

        const seen = new Set();
        const mergeDynamicContent = [...postDynamicValues, ...(oldDynamicValue || [])].filter(item => {
            const key = `${item.type}_${item.displayName}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });

        // Filter out dynamic values no longer in content
        const updatedDynamicValues = mergeDynamicContent.filter(({ type, displayName }) => {
            const prefix = type === "UserMention" ? "@" : "#";
            const fullMention = `${prefix}${displayName}`;
            return value.includes(fullMention);
        });

        // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
        // const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
        //     ...item,
        //     dVno: index + 1
        // }));

        const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
            dVno: index + 1,
            displayName: item.displayName,
            entity: item.entityID || item.entity,
            type: item.type
        }));

        setPostDynamicValues(reassignedDynamicValues);

        // Recompute postInputValue
        const updatedPostInputValue = updatePostInputValueWithDynamicValues(value, reassignedDynamicValues);
        setPostInputValue(updatedPostInputValue);
    };

    // const handleChange = (e) => {
    //     const value = e.target.value;
    //     const caret = e.target.selectionStart;

    //     setContent(value);
    //     setCursorPosition(caret);
    //     detectTrigger(value, caret);

    //     // Step 1: Extract all words starting with @ or #
    //     const mentionMatches = [...value.matchAll(/(@\w[\w\s]*)/g)];
    //     const hashtagMatches = [...value.matchAll(/(#\w[\w\d]*)/g)];

    //     // Step 2: Build a new set from detected @ and # words
    //     const mentions = mentionMatches.map(m => m[0].trim());
    //     const hashtags = hashtagMatches.map(h => h[0].trim());

    //     const allEntities = [...mentions, ...hashtags];

    //     // Step 3: Build new dynamic values list using previous + old + new entities
    //     const updatedDynamicValues = allEntities.map((entity, index) => {
    //         const isMention = entity.startsWith("@");
    //         const type = isMention ? "UserMention" : "Hashtag";
    //         const displayName = entity.slice(1);

    //         // Try to reuse from postDynamicValues first
    //         const existingFromCurrent = postDynamicValues.find(
    //             (dv) => dv.displayName === displayName && dv.type === type
    //         );

    //         // Fallback to oldDynamicValues if not in postDynamicValues
    //         const existingFromOld = (oldDynamicValue || []).find(
    //             (dv) => dv.displayName === displayName && dv.type === type
    //         );

    //         return {
    //             ...(existingFromCurrent || existingFromOld || {}), // fallback order
    //             type,
    //             displayName,
    //             dVno: index + 1,
    //         };
    //     });

    //     // Step 4: Set updated state
    //     setPostDynamicValues(updatedDynamicValues);

    //     // Step 5: Generate updated raw value
    //     const updatedPostInputValue = updatePostInputValueWithDynamicValues(value, updatedDynamicValues);
    //     setPostInputValue(updatedPostInputValue);
    // };

    const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
        let modifiedText = rawContent;

        dynamicValues.forEach(({ type, dVno, displayName }) => {
            const prefix = type === "UserMention" ? "@" : "#";
            const fullMention = `${prefix}${displayName}`;
            const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
            modifiedText = modifiedText.replace(regex, `{${dVno}}`);
        });

        return modifiedText.trim();
    };

    // Detect @ or #
    const detectTrigger = (value, caret) => {
        const textBeforeCursor = value.slice(0, caret);
        const match = textBeforeCursor.match(/([@#])(\w*)$/);
        if (match) {
            const trigger = match[1];
            const q = match[2];
            setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
            setQuery(q);
            fetchSuggestions(q, trigger);
            setSearchText(q)
        } else {
            // if (match[1] === "#") {
            //     setShowSuggestions(true);
            // } else {
            //     setShowSuggestions(false);
            // }
            setSearchText('')
        }
    };
    const fetchSuggestions = async (searchText, triggerChar) => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
        };

        try {
            if (triggerChar === "@") {
                const res = await axios.post(`General/MentionTagDDL?Search=${searchText}`, data);
                const results = res.data.responseData || [];
                setSuggestions(results);
                setShowSuggestions(results.length > 0);
            } else if (triggerChar === "#") {
                const res = await axios.post(`General/HashtagDDL?SearchHashtag=${searchText}`, data);
                const results = res.data.responseData || [];
                setSuggestions(results);
                setShowSuggestions(true);
            }
        } catch (err) {
            console.error(err);
            if (triggerChar === "#" && searchText) {
                setShowSuggestions(true);
            } else {
                setShowSuggestions(false);
            }
        }
    };

    useEffect(() => {
        const textarea = document.getElementById("commentTextArea");
        if (textarea) {
            textarea.setSelectionRange(cursorPosition, cursorPosition);
            textarea.focus();
        }
    }, [cursorPosition]);


    const insertMention = (suggestion, userUid) => {
        const input = editorRef.current;
        if (!input) return;

        //DS - code change
        setIsDynamicValueChange(true);

        input.focus();

        const cursorPos = input.selectionStart;
        const textBeforeCursor = input.value.slice(0, cursorPos);
        const textAfterCursor = input.value.slice(cursorPos);

        const match = textBeforeCursor.match(/[@#]\w*$/);
        if (!match) return;

        const startIndex = cursorPos - match[0].length;
        const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
        const displayName = suggestion;
        const mentionText = `${mentionPrefix}${displayName} `;

        const updatedText = textBeforeCursor.slice(0, startIndex) + mentionText + textAfterCursor;

        // ✅ Set content state immediately (DON’T rely only on input.value)
        setContent(updatedText);

        const newCursorPosition = startIndex + mentionText.length;
        setCursorPosition(newCursorPosition); // React will move cursor on next render

        const dVno = postDynamicValues.length + 1;

        const updatedPostDynamicValues = [
            ...postDynamicValues,
            {
                type: mentionType,
                dVno,
                entity: mentionType === "UserMention" ? userUid : suggestion,
                displayName,
            },
        ];
        setPostDynamicValues(updatedPostDynamicValues);

        console.log("updatedPostDynamicValues", updatedPostDynamicValues);
        // Replace mention text with placeholders
        let modifiedText = updatedText;
        updatedPostDynamicValues.forEach(({ type, dVno, displayName }) => {
            const prefix = type === "UserMention" ? "@" : "#";
            const fullMention = `${prefix}${displayName}`;
            const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
            modifiedText = modifiedText.replace(regex, `{${dVno}}`);
        });

        setPostInputValue(modifiedText.trim());
        setContent(updatedText); // Shows actual mention text (with @ or #) in input

        setShowSuggestions(false);
        setSearchText('')
    };


    // Helper: Escape regex special characters
    const escapeRegex = (str) => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };
    // console.log('postList', postList);

    const regenerateReadableComment = (comment, dynamicValues) => {
        if (!comment || !dynamicValues?.length) return comment;

        let newComment = comment;

        dynamicValues.forEach((item) => {
            const placeholder = `{${item.dVno}}`;

            let readable;

            if (item.type === "UserMention") {
                readable = `<a href="/user/${item.entityID || item.entity}" class="user-mention">@${item.displayName}</a>`;
            } else if (item.type === "Hashtag") {
                readable = `<a href="/hashtag/${item.displayName}" class="hashtag">#${item.displayName}</a>`;
            } else {
                readable = item.displayName;
            }

            newComment = newComment.replaceAll(placeholder, readable);
        });

        return newComment;
    };

    const cancelEditHandler = () => {
        const updatedDynamicValue = oldDynamicValue
        setEditedDynamicValue(updatedDynamicValue);
        const parsedComment = regenerateReadableComment(oldPostInputValue, oldDynamicValue);
        handleCommentChange(parsedComment, oldDynamicValue);
        setIsEditing(false);
    }


    return (
        <>
            {isEditing ? (
                <div className="edit-comment" style={{ position: 'relative' }}>
                    <input
                        ref={editorRef}
                        type="text"
                        value={content} // Now editable
                        onChange={handleChange}
                        className="form-control"
                    />
                    {
                        showSuggestions ?
                            <ul style={{
                                position: "absolute",
                                top: "30px", // adjust based on input position
                                left: "0",
                                zIndex: 10,
                                background: "#fff",
                                border: "1px solid #ccc",
                                width: "100%",
                                listStyle: "none",
                                padding: "0",
                                margin: "0",
                                maxHeight: "150px",
                                overflowY: "auto"
                            }}>
                                {mentionType === "Hashtag" ? <li
                                    onMouseDown={(e) => {
                                        e.preventDefault(); // Prevent editor blur
                                        insertMention(
                                            SearchText,
                                            null
                                        );
                                    }}
                                    className="suggestion-item"
                                >
                                    <span>{SearchText ? `#${SearchText}` : ''}</span>
                                </li> : null}

                                {suggestions.map((item, index) => (
                                    <li
                                        key={index}
                                        onMouseDown={(e) => {
                                            e.preventDefault(); // Prevent editor blur
                                            insertMention(
                                                mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                                                mentionType === "UserMention" ? item?.userUid : null
                                            );
                                        }}
                                        className="suggestion-item"
                                    >
                                        {mentionType === "UserMention" ? (
                                            <>
                                                <img
                                                    src={item?.avatar}
                                                    alt={item?.entityName}
                                                    className="avatar"
                                                />
                                                <span>{item?.entityName}</span>
                                            </>
                                        ) : (
                                            <span>#{item?.hashTag}</span>
                                        )}
                                    </li>
                                ))}
                            </ul> : null
                    }
                    <button disabled={saveDisabled} onClick={handleSaveComment} className="wljPrimaryBtn mt-2">
                        Save
                    </button>
                    <button
                        onClick={cancelEditHandler}
                        className="wljSecondaryBtn ms-3 mt-2"
                    >
                        Cancel
                    </button>
                </div>
            ) : (
                <p className="f-14">{content}</p> // Show the final comment
            )}
        </>
    );
};

export default EditComment;